// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"04f5abe5","316":"004b418e","346":"956f99e0","453":"bf8e260e","515":"34dd799b","815":"23fa015e","917":"1c9e235e","951":"3598f4c2"}[chunkId] + ".chunk.js";
};